import { BaseApiRouteService } from "mrb/core";

class AppStoreHomeSectionApiRouteService extends BaseApiRouteService {
    constructor() {
        super("app-store-home-sections");
    }

    getLoadioAll(options) {
        return super.find(`${this.base}/loadio-all{?embed}`, options);
    }

    getNakiAll(options) {
        return super.find(`${this.base}/naki-all{?embed}`, options);
    }

    getLoadioContent(options) {
        return super.find(`${this.base}/loadio-content{?searchQuery,page,rpp}`, options);
    }

    getNakiContent(options) {
        return super.find(`${this.base}/naki-content{?searchQuery,page,rpp}`, options);
    }

    getLoadioFeatured(options) {
        return super.find(`${this.base}/loadio-featured{?embed}`, options);
    }

    getNakiFeatured(options) {
        return super.find(`${this.base}/naki-featured{?embed}`, options);
    }

    get(id, options) {
        return super.get(`${this.base}/{id}{?embed,fields}`, id, options);
    }

    create(resource) {
        return super.create(this.base, resource);
    }

    updateNaki(resource) {
        return super.update(`${this.base}/naki`, resource);
    }

    updateLoadio(resource) {
        return super.update(`${this.base}/loadio`, resource);
    }

    updateLoadioFeatured(resource) {
        return super.update(`${this.base}/loadio-featured`, resource);
    }

    updateNakiFeatured(resource) {
        return super.update(`${this.base}/naki-featured`, resource);
    }

    delete(resource) {
        return super.delete(`${this.base}/{id}`, resource);
    }
}

export default AppStoreHomeSectionApiRouteService;
